export default {
  SET_CLIPBOARD_DATA: '@WS/SET_CLIPBOARD_DATA',
};
